export const INLINE_TOKEN_CLASS =
  'inline-flex h-4 items-center rounded-md px-2 py-1 text-sm leading-5 align-middle';

export const INLINE_TOKEN_DROPDOWN_WIDTH = 'w-fit min-w-[5rem]';

export const DEFAULT_DROPDOWN_TOKEN_CLASS_NAME =
  'bg-muted border-border text-foreground';

export const INLINE_TOKEN_INPUT_WRAPPER_CLASS =
  'inline-flex h-6 items-center rounded-md border bg-background px-2 align-middle transition-colors focus-within:border-primary';

export const INLINE_TOKEN_INPUT_ELEMENT_CLASS =
  'h-6 leading-6 appearance-none bg-transparent outline-none focus-visible:ring-0 focus-visible:ring-offset-0 p-0 m-0 text-sm text-center';
